import React, { memo, useState, useEffect, useCallback } from 'react'
import NumberRange from '@/components/NumberRange'

const Index = (props: any) => {
    const [state, setState] = useState('')

    useEffect(() => {

    })

    return (<div><NumberRange /></div>)
}

export default Index